<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 class="text-sm-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" outline>
                  <v-icon class="mr-2">save</v-icon>
                  Export CSV
                </v-btn>
                <v-btn color="blue darken-3" class="ma-0 mb-3 ml-2" outline>
                  <v-icon class="mr-2">save</v-icon>
                  Export XLS
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <div class="table-border__radius elevation-1">
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    :loading="loadingTable"
                    :pagination.sync="pagination"
                    :total-items="pagination.totalItems"
                    :rows-per-page-items="[25, 50, 100, 200]"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.datum_sjednani }}</td>
                      <td>{{ props.item.sporici_program }}</td>
                      <td>{{ props.item.nazev_osoby }}</td>
                      <td>{{ props.item.sporici_program }}</td>
                      <td>{{ props.item.cilovy_produkt }}</td>
                      <td>{{ props.item.variabilni_symbol }}</td>
                      <td>{{ props.item.min_cilova_castka }}</td>
                      <td>{{ props.item.min_mesicni_splatka }}</td>
                      <td>{{ props.item.prvni_platba }}</td>
                      <td>{{ props.item.zaplaceno_procento }}</td>
                      <td class="text-center">
                        <router-link :to="{ path: '/objednavky-sporici/'+props.item.id }">
                          <v-btn color="primary" class="elevation-0">
                          <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                        </router-link>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Datum sjednání', value: 'datum_sjednani' },
        { text: 'Název spoření', value: 'sporici_program' },
        { text: 'Jméno klienta', value: 'jmeno_klienta' },
        { text: 'Spořící program', value: 'sporici_program' },
        { text: 'Cílový produkt', value: 'cilovy_produkt' },
        { text: 'VS', value: 'variabilni_symbol' },
        { text: 'Cílová částka', value: 'min_cilova_castka' },
        { text: 'Měsíční platba', value: 'min_mesicni_splatka' },
        { text: 'První platba', value: 'prvni_platba' },
        { text: 'Zaplacené (%)', value: 'zaplaceno_procento' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      dialogCreate: false,
      sending: false,
      dialogInit: {
        sporici_program: null,
        hlavni_cilovy_produkt_id: null,
        mena_id: null
      },
      newItem: null,
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("sporici-produkty/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("sporici-produkty", this.newItem).then(function(body) {
          if (body.inserted) {
            this.$router.push({path:"/sporici-produkty/"+body.data.id});
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Objednavky/Objednavky.vue